import {
  PayloadAction,
  createSelector,
  createSlice,
  isAnyOf
} from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { RowToggledPayload } from './advanced-reports-table.types';
import { advancedReportQueryApi } from 'app/apis/advanced-reports/advanced-report-query-api';
import { selectSite } from 'features/topbar/selectedSiteSlice';
import { resetAdvancedReports } from '../advanced-reports.middleware';

interface AdvancedReportsTableState {
  openRowIds: string[];
}

const initialState: AdvancedReportsTableState = {
  openRowIds: []
};

const advancedReportsTableSlice = createSlice({
  name: 'advancedReportsTable',
  initialState,
  reducers: {
    onRowToggled: (state, action: PayloadAction<RowToggledPayload>) => {
      state.openRowIds = state.openRowIds.includes(action.payload.rowId)
        ? state.openRowIds.filter((id) => id !== action.payload.rowId)
        : [...state.openRowIds, action.payload.rowId];
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        advancedReportQueryApi.endpoints.getClicksAdvancedReport.matchFulfilled,
        advancedReportQueryApi.endpoints.getConversionAdvancedReport
          .matchFulfilled,
        advancedReportQueryApi.endpoints.getOpportunityAdvancedReport
          .matchFulfilled,
        advancedReportQueryApi.endpoints.getRevenueAdvancedReport
          .matchFulfilled,
        advancedReportQueryApi.endpoints.getCostAdvancedReport.matchFulfilled,
        selectSite,
        resetAdvancedReports
      ),
      () => initialState
    );
  }
});

const { actions, reducer } = advancedReportsTableSlice;

export const { onRowToggled } = actions;

export default reducer;

export const selectAdvancedReportsTableState = (state: RootState) =>
  state.advancedReportsTable;

export const selectOpenRowIds = createSelector(
  selectAdvancedReportsTableState,
  (state) => state.openRowIds
);

export const selectIsRowOpen = createSelector(
  (state: RootState) => state.advancedReportsTable,
  (_: RootState, rowId: string) => rowId,
  (state, rowId) => state.openRowIds.includes(rowId)
);
